// Test de Fagerström (Fagerström Test for Nicotine Dependence, 1991), six
// questions, score de 0 à 10. Libellés et grille d'interprétation d'après la
// version française de la HAS (recommandations sur l'arrêt du tabac, 2014).
export const QUESTIONS = [
  {
    key: "q1",
    title: "Combien de temps après votre réveil fumez-vous votre première cigarette ?",
    options: [
      { score: 3, label: "Dans les 5 minutes" },
      { score: 2, label: "Entre 6 et 30 minutes" },
      { score: 1, label: "Entre 31 et 60 minutes" },
      { score: 0, label: "Après 60 minutes" },
    ],
  },
  {
    key: "q2",
    title: "Trouvez-vous difficile de vous abstenir de fumer dans les endroits où c'est interdit ?",
    options: [
      { score: 1, label: "Oui" },
      { score: 0, label: "Non" },
    ],
  },
  {
    key: "q3",
    title: "À quelle cigarette de la journée renonceriez-vous le plus difficilement ?",
    options: [
      { score: 1, label: "La première le matin" },
      { score: 0, label: "N'importe quelle autre" },
    ],
  },
  {
    key: "q4",
    title: "Combien de cigarettes fumez-vous par jour, en moyenne ?",
    options: [
      { score: 0, label: "10 ou moins" },
      { score: 1, label: "De 11 à 20" },
      { score: 2, label: "De 21 à 30" },
      { score: 3, label: "31 ou plus" },
    ],
  },
  {
    key: "q5",
    title: "Fumez-vous à intervalles plus rapprochés durant les premières heures de la matinée que durant le reste de la journée ?",
    options: [
      { score: 1, label: "Oui" },
      { score: 0, label: "Non" },
    ],
  },
  {
    key: "q6",
    title: "Fumez-vous lorsque vous êtes malade, au point de devoir rester au lit presque toute la journée ?",
    options: [
      { score: 1, label: "Oui" },
      { score: 0, label: "Non" },
    ],
  },
];

// values: { q1: score, ... }, undefined while unanswered.
export function evaluate(values) {
  const answered = QUESTIONS.filter((q) => values[q.key] !== undefined).length;
  const complete = answered === QUESTIONS.length;
  const total = complete ? QUESTIONS.reduce((sum, q) => sum + values[q.key], 0) : null;
  // Heaviness of Smoking Index : questions 1 et 4 seulement, de 0 à 6.
  const hsi = values.q1 !== undefined && values.q4 !== undefined ? values.q1 + values.q4 : null;
  return { answered, complete, total, hsi, level: total === null ? null : levelFor(total) };
}

// Grille HAS : 0-2 pas de dépendance, 3-4 faible, 5-6 moyenne, 7-10 forte.
export function levelFor(total) {
  if (total <= 2) return { key: "none", label: "Pas de dépendance à la nicotine" };
  if (total <= 4) return { key: "low", label: "Dépendance faible" };
  if (total <= 6) return { key: "medium", label: "Dépendance moyenne" };
  return { key: "high", label: "Dépendance forte" };
}

export function hsiLevelFor(hsi) {
  if (hsi <= 1) return "faible";
  if (hsi <= 4) return "modérée";
  return "forte";
}
